import store from "store"
import {EventBus} from "@/Bus";
import ReconnectingWebSocket from "@/Services/ReconnectingWebSocket";

const TOKEN_KEY = "mm-chat.token";
const Event = {
    Error: {
        Auth: "error.auth"
    },
    Msg: {
        InComing: "msg.incoming",
        OutGoing: "msg.outgoing"
    },
    Heartbeat: "heartbeat"
};


class WSService {
    constructor() {
        this.api = global.WS_URI || "ws://mm-chat.demo2.mixmedia.com/io/ws";
        this.token = "";
        /**
         * @type {ReconnectingWebSocket|null}
         */
        this.client = null;

        const wsRule = /^ws(s?):\/\//i;
        if (!wsRule.test(this.api)) {
            const host = window.location.host
            const protocol = location.protocol.includes('https') ? 'wss' : 'ws';
            this.api = `${protocol}://${host}${this.api}`;
        }
    }

    connect() {
        return new Promise(( resolve, reject ) => {

            if(this.client) {
                try {
                    this.close();
                } catch(err) {
                    console.error(err);
                }
            }

            this.client =  new ReconnectingWebSocket(this.api, {
                token: store.get(TOKEN_KEY) || '',
            });

            this.client.on('message', msg => {

                if (msg.event === Event.Error.Auth) {
                    console.error("ws error:auth");
                    EventBus.dispatchAuthError();
                    this.client.close(true);
                }

                if (msg.event === Event.Msg.InComing) {
                    EventBus.dispatchContactUpdated({
                        fromData: msg.data?.from,
                        time: msg.data?.time
                    });
                    EventBus.dispatchNewMessage(msg);
                }
                if (msg.event === Event.Msg.OutGoing) {
                    EventBus.dispatchNewMessage(msg);
                }
            })

            this.client.on('open', () => {
                resolve();
            })

            this.client.on('error', event => {
                reject(event);
                console.error("Connection Error: " + event.toString());
            })
        })
    }

    isActive() {
        return this.client && this.client.isConnected();
    }

    close() {
        this.client.close();
    }

    onMessage( callback ) {
        if (this.client) {
            this.client.on("message", callback)
        }
    }

    offMessage(callback = null) {
        if (this.client) {
            this.client.off("message", callback)
        }
    }

    static getInstance() {
        if (!global.wsService) global.wsService = new WSService();
        return global.wsService;
    }

    static get Event() {
        return Event;
    }
}

export default WSService;
